import { render, staticRenderFns } from "./AddImportComponent.vue?vue&type=template&id=25d2b0a7"
import script from "./AddImportComponent.vue?vue&type=script&lang=js"
export * from "./AddImportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports